import stateChatBot from './stateChatBot';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'; // ✅ IMPORTAR getters

export default {
  state: stateChatBot,
  mutations,
  actions,
  namespaced: true,
    getters, // ✅ AGREGAR getters aquí

};
